import ClubIcon from "@medoma/components/icons/ClubIcon";
import DiamondIcon from "@medoma/components/icons/DiamondIcon";
import HexagonIcon from "@medoma/components/icons/HexagonIcon";
import PyramidIcon from "@medoma/components/icons/PyramidIcon";
import SpadeIcon from "@medoma/components/icons/SpadeIcon";
import TriangleIcon from "@medoma/components/icons/TriangleIcon";
import type { ITeam } from "@medoma/models/patients";

type TeamVisual = {
  icon: React.ReactNode;
  color: ITeam["displayColor"];
};

const icons: React.ReactNode[] = [
  <HexagonIcon key="hexagon" />,
  <ClubIcon key="club" />,
  <DiamondIcon key="diamond" />,
  <TriangleIcon key="triangle" />,
  <PyramidIcon key="pyramid" />,
  <SpadeIcon key="spade" />,
];

// Generates icon based on team ID; color comes from backend displayColor
export const getTeamVisual = (team: ITeam): TeamVisual => {
  const index = team.id - 1;
  const round = Math.floor(index / icons.length);
  const iconIndex = (index + round) % icons.length;

  return {
    color: team.displayColor,
    icon: icons[iconIndex]!,
  };
};
